import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
// import axiosInstance from "../../utils/axiosApi";
import axiosInstance from "../../utils/axiosKeycloakApi";
import NavBar from "../../components/Navbar/Navbar";
import "./PandDetail.css";
import Tooltip from "@mui/material/Tooltip";
import { useKeycloak } from "@react-keycloak/web";

const PandDetail = () => {
  // Verkrijg ID uit URL parameter
  let { id } = useParams();
  const { keycloak, initialized } = useKeycloak();
  const [pandDetails, setPandDetails] = useState({
    plaats: "",
    pandnaam: "",
    omschrijving: "",
    adres: "",
    afbeelding_url: "",
    onderhoudstaken: [],
  });

  // const getPandDetails = async () => {
  //   try {
  //     await axiosInstance
  //       .get(`https://iamposshowcase.ig-nl.com/api/panden/${id}/`)
  //       .then((response) => {
  //         setPandDetails(response.data);
  //         return response.data;
  //       });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const getPandDetails = async () => {

   
    
    if (!!keycloak.authenticated){
      localStorage.setItem("access_token", keycloak.token)
      console.log("user is authenticated, setting the access token");
    };
    if (!keycloak.authenticated){
      localStorage.setItem("access_token", null)
      window.location = `/app/`;
      console.log("user is NOT authenticated on PandDetail, setting null token in local storage");
    };

    try {
      await axiosInstance
        .get(`/panden/${id}/`)
        .then((response) => {
          setPandDetails(response.data);
          return response.data;
        });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getPandDetails();
  }, [id]);

  let toonOnderhoudstaken = () => {
    return pandDetails.onderhoudstaken.map((onderhoudstaak, index) => {
      return (
        <tr key={index}>
          <td>{onderhoudstaak.omschrijving}</td>
          <td>{onderhoudstaak.kosten}</td>
        </tr>
      );
    });
  };

  const currentUser = JSON.parse(localStorage.getItem("current_user_data"));

  // const userHeeftRol = (role) => {
  //   // ID's van groepen in de database
  //   const manager = 6;
  //   const pandinformatiebeheerder = 5;

  //   switch (role) {
  //     case "manager":
  //       return currentUser.groups.includes(manager) ? true : false;

  //     case "pandinformatiebeheerder":
  //       return currentUser.groups.includes(pandinformatiebeheerder)
  //         ? true
  //         : false;

  //     default:
  //       console.log("Deze rol wordt niet ondersteund.");
  //       break;
  //   }
  // };

  const  userHeeftRol = (role) => {
    return true;
  };

  return (
    <>
      <NavBar />
      <div className="pand-detail">
        <div className="columns">
          <div className="column">
            <section className="section">
              <div className="container box">
                {userHeeftRol("pandinformatiebeheerder") ? (
                  <Link
                    className="button is-info is-small is-outlined"
                    to={{
                      pathname: `/panden/${id}/edit`,
                      state: { pandDetails: pandDetails },
                    }}
                  >
                    <i className="far fa-edit edit-button-icon" />
                    <p className="edit-button-text">
                      <strong>Bewerk pandinformatie</strong>
                    </p>
                  </Link>
                ) : (
                  <Tooltip
                    title="Je hebt niet de juiste bevoegdheden"
                    placement="bottom"
                  >
                    <button
                      className="button is-dark is-small disabled-button"
                      disabled
                    >
                      <i className="far fa-edit edit-button-icon" />
                      <span>Bewerk pandinformatie (niet mogelijk)</span>
                    </button>
                  </Tooltip>
                )}
                <br />
                <br />
                <h1 className="title is-2">{pandDetails.pandnaam}</h1>
                <h2 className="subtitle is-4">
                  <strong>{pandDetails.adres}</strong>
                </h2>

                <p className="omschrijving">{pandDetails.omschrijving}</p>
              </div>
            </section>
          </div>
          <div className="column">
            <section className="section">
              <div className="container">
                <figure className="image">
                  <img
                    className="pand-img"
                    src={pandDetails.afbeelding_url}
                    alt="Afbeelding van pand"
                  />
                </figure>
                <div className="box table-box">
                  {userHeeftRol("manager") ? (
                    <Link
                      className="button is-info is-small is-outlined"
                      to={{
                        pathname: `/panden/${id}/onderhoudstaken/edit`,
                        state: { pandDetails: pandDetails },
                      }}
                    >
                      <i className="far fa-edit edit-button-icon" />
                      <p className="edit-button-text">
                        <strong>Bewerk onderhoudstaken</strong>
                      </p>
                    </Link>
                  ) : (
                    <Tooltip
                      title="Je hebt niet de juiste bevoegdheden"
                      placement="bottom"
                    >
                      <button
                        className="button is-dark is-small disabled-button"
                        disabled
                      >
                        <i className="far fa-edit edit-button-icon" />
                        <strong>Bewerk onderhoudstaken (niet mogelijk)</strong>
                      </button>
                    </Tooltip>
                  )}
                  <br />
                  <br />
                  <h3 className="title is-4">Onderhoudstaken</h3>
                  <table className="table is-fullwidth">
                    <thead>
                      <tr>
                        <th>Omschrijving</th>
                        <th>Kosten</th>
                      </tr>
                    </thead>
                    <tbody>{toonOnderhoudstaken()}</tbody>
                  </table>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default PandDetail;
